import { Button, CircularProgress, DialogActions, DialogContentText, Divider, Typography } from '@material-ui/core';
import { Dispatch } from '@reduxjs/toolkit';
import React, { Component, Fragment } from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { AppDispatch, AppState } from 'store';
import { DialogOpenPayloadJobs } from 'store/dialog/dialog.interface';
import { contentChangedIgnore, contentChangedSend, contentChangedUpdate } from 'store/projects/projects.actions';
import {
  getJobActionSpinnerSelector,
  getSecondJobActionSpinnerSelector,
  getThirdJobActionSpinnerSelector,
} from 'store/spinner/spinner.selectors';
import { ChangedKontentRequest } from 'utils/restApplicationClient';
import { CustomDialogButtonContainer, CustomDialogContent } from '../CustomDialog.styled';

interface IProps {
  jobs: DialogOpenPayloadJobs;
  errorMessage: string;
  projectId: string;
  projectLanguages: Array<string>;
}

interface IDispatchProps {
  contentChangedIgnore: (payload: ChangedKontentRequest) => AppDispatch;
  contentChangedUpdate: (payload: ChangedKontentRequest) => AppDispatch;
  contentChangedSend: (payload: ChangedKontentRequest) => AppDispatch;
}

interface IStateProps {
  jobActionSpinner: boolean;
  secondJobActionSpinner: boolean;
  thirdJobActionSpinner: boolean;
}

type PropType = IProps & WithTranslation & IDispatchProps & IStateProps;

class ContentChangedCms extends Component<PropType> {
  handleUpdateClick = (): void => {
    const { contentChangedUpdate, jobs } = this.props;

    contentChangedUpdate({
      operation: 'UPDATE',
      requestId: jobs[0].id,
    });
  };

  handleNewClick = (): void => {
    const { contentChangedSend, jobs } = this.props;

    contentChangedSend({
      operation: 'CREATE_NEW',
      requestId: jobs[0].id,
    });
  };

  handleIgnoreClick = (): void => {
    const { contentChangedIgnore, jobs } = this.props;

    contentChangedIgnore({
      operation: 'IGNORE',
      requestId: jobs[0].id,
    });
  };

  render(): JSX.Element {
    const { jobActionSpinner, secondJobActionSpinner, thirdJobActionSpinner, t } = this.props;
    const isDisabled = jobActionSpinner || secondJobActionSpinner || thirdJobActionSpinner;

    return (
      <Fragment>
        <CustomDialogContent>
          <DialogContentText>
            <Typography component="span" color="textPrimary">
              {t('modal.contentChangedAction1')}
            </Typography>
            <br />
            <Typography component="span" color="textPrimary">
              {t('modal.contentChangedAction2')}
            </Typography>
          </DialogContentText>
        </CustomDialogContent>
        <Divider />
        <DialogActions>
          <CustomDialogButtonContainer>
            <Button color="secondary" disabled={isDisabled} variant="contained" onClick={this.handleUpdateClick}>
              {(jobActionSpinner && <CircularProgress size="24px" color="secondary" />) || t('modal.updateExisting')}
            </Button>
            <Button variant="outlined" disabled={isDisabled} onClick={this.handleNewClick}>
              {(secondJobActionSpinner && <CircularProgress size="24px" />) || t('modal.sendAsNew')}
            </Button>
            <Button variant="outlined" disabled={isDisabled} onClick={this.handleIgnoreClick}>
              {(thirdJobActionSpinner && <CircularProgress size="24px" />) || t('modal.ignoreUpdates')}
            </Button>
          </CustomDialogButtonContainer>
        </DialogActions>
      </Fragment>
    );
  }
}

const mapStateToProps = (state: AppState): IStateProps => ({
  jobActionSpinner: getJobActionSpinnerSelector(state),
  secondJobActionSpinner: getSecondJobActionSpinnerSelector(state),
  thirdJobActionSpinner: getThirdJobActionSpinnerSelector(state),
});

const mapDispatchToProps = (dispatch: Dispatch<AppDispatch>): IDispatchProps => ({
  contentChangedIgnore: (payload: ChangedKontentRequest): AppDispatch => dispatch(contentChangedIgnore(payload)),
  contentChangedSend: (payload: ChangedKontentRequest): AppDispatch => dispatch(contentChangedSend(payload)),
  contentChangedUpdate: (payload: ChangedKontentRequest): AppDispatch => dispatch(contentChangedUpdate(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ContentChangedCms));
